<template>
  <div class="page-container">
    <div class="header">
      <div class="title">提现记录</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="120px"
        label-position="left">
        <el-row>
          <el-col :span="6">
            <el-form-item label="余额提现单号" size="small">
              <el-input v-model="form.withdrawalSerialNo" placeholder="请输入余额提现单号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提现发起时间" size="small">
              <el-date-picker
                v-model="dateTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="提现状态" size="small">
              <el-select v-model="form.withdrawalStatus">
                <el-option
                  v-for="(item, index) in withdrawalStatusOptions"
                  :value="item.value"
                  :label="item.label"
                  :key="index"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="withdrawalSerialNo" label="余额提现单号" align="center" min-width="250px"/>
        <el-table-column prop="merchantId" label="商户编号" align="center" min-width="150px"/>
        <el-table-column prop="merchantName" label="商户名称" align="center" min-width="150px"/>
        <el-table-column prop="managerType" label="开户类型" align="center" min-width="150px">
          <template slot-scope="{row: {managerType}}">{{ managerType === 1 ? '分账方' : '接收方' }}</template>
        </el-table-column>
        <el-table-column prop="bankName" label="开户银行" align="center" min-width="150px"/>
        <el-table-column prop="bankHolder" label="开户名称" align="center" min-width="150px"/>
        <el-table-column prop="bankCardNo" label="银行卡号" align="center" min-width="150px"/>
        <el-table-column prop="withdrawalAmount" label="提现金额" align="center" min-width="150px">
          <template slot-scope="{row: {withdrawalAmount}}">{{ divide(withdrawalAmount, 100) }}</template>
        </el-table-column>
        <el-table-column prop="actualAmount" label="实际到账金额" align="center" min-width="150px">
          <template slot-scope="{row: {actualAmount}}">{{ divide(actualAmount, 100) }}</template>
        </el-table-column>
        <el-table-column prop="withdrawalStatus" label="提现状态" align="center" min-width="150px">
          <template slot-scope="{row: {withdrawalStatus}}">
            {{ withdrawalStatusOptions.find(item => item.value === withdrawalStatus).label }}
          </template>
        </el-table-column>
        <el-table-column prop="withdrawalRemark" label="失败原因" align="center" min-width="150px"/>
        <el-table-column prop="createTime" label="提现发起时间" align="center" min-width="200px"/>
        <el-table-column prop="updateTime" label="提现到账时间" align="center" min-width="200px"/>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { exportListWithdrawRecords, exportPageSplitSerial, queryListWithdrawRecords } from '../../../api/cloud-manage';
import { debounce } from "@/utils/index";
import { divide, multiply, subtract } from '../../../utils/math';

const FORMAT = 'yyyy-MM-DD HH:mm:ss';
const start = moment().subtract(90, 'days').startOf('d').format(FORMAT);
const end = moment().endOf('d').format(FORMAT);
export default {
  name: "withdrawal-records",
  data() {
    return {
      withdrawalStatusOptions: [
        { value: 1, label: '提现中' },
        { value: 2, label: '提现成功' },
        { value: 3, label: '提现失败' },
      ],
      dateTimeRange: [start, end],
      pickerOptions: {
        disabledDate(time) {
          // 日期只能选最近三个月的时间
          const threeMonthAgo = moment().subtract(90, 'days').valueOf();
          return moment(time).valueOf() < threeMonthAgo;
        },
      },
      form: {
        withdrawalSerialNo: '',
        withdrawalStatus: '',
      },
      exportLoading: false,
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
  },
  mounted() {
    if (this.$route.query.withdrawalStatus) {
      this.form.withdrawalStatus = parseInt(this.$route.query.withdrawalStatus, 10);
    }
    this.handleFormSearch();
  },
  methods: {
    divide,
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        withdrawalSerialNo: '',
        withdrawalStatus: '',
      };
      this.dateTimeRange = [start, end];
      this.handleFormSearch();
    },
    exportTableFunc() {
      const [startTime, endTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        startTime,
        endTime,
      };
      this.exportLoading = true;
      exportListWithdrawRecords(params).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    async queryTableData() {
      const { pageNo, pageSize } = this.table;
      const [startTime, endTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        pageNo,
        pageSize,
        startTime,
        endTime,
      };
      this.table.loading = true;
      const { data: { data: { list = [], totalCount = 0 } } } = await queryListWithdrawRecords(params).finally(() => {
        this.table.loading = false;
      });
      this.table.data = list;
      this.table.totalCount = totalCount;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>
